import React from 'react'
import Checkout from '../features/checkout/Components/Checkout';

const CheckoutPaymentPage = () => {
  document.title = "Complete Your Payment";

  return (
    <Checkout />
  )
}

export default CheckoutPaymentPage